var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{ref:"file",attrs:{"type":"file","accept":"image/*","id":"file"},on:{"change":function($event){return _vm.handleFileUpload()}}}),_c('b-form-invalid-feedback',{attrs:{"state":_vm.validated}},[_vm._v(_vm._s(_vm.error))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }